import React from 'react';
import PropTypes from 'prop-types';
import IconUtil from "./IconUtil.js";
import Theme from "./Theme.js";
import S from './Text.css';

/**
 * React class to render a block of text
 * @property {string} className - css class to be applied to this component
 * @property {string} variant - Theme variant name to be added to the component
 * */
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
class Text extends React.Component {
  static contextType = Theme.Context;
  static propTypes = {
    className: PropTypes.string,
    variant: PropTypes.string,
    layoutOptions: PropTypes.object,
    disabled: PropTypes.bool
  };
  static defaultProps = {
    className: null,
    variant: null,
    layoutOptions: {},
    disabled: false
  };
  render() {
    const theme = this.context;
    // eslint-disable-next-line no-unused-vars
    const {
      className,
      variant,
      layoutOptions,
      disabled,
      icon,
      imageOpts,
      iconOpts,
      disabledIcon,
      children,
      useEllipsis,
      ...rest
    } = theme.props('Text', this.props);
    const ellipsisClass = useEllipsis ? S.ellipsis : undefined;
    const iView = icon ? IconUtil.create(disabled ? disabledIcon || icon : icon, imageOpts, iconOpts, theme) : null;
    if (iView) {
      return /*#__PURE__*/_jsxs("div", {
        className: theme.classes('Text', 'text', variant, className, S.iconLayout),
        "data-disabled": disabled,
        ...rest,
        children: [iView, children && /*#__PURE__*/_jsx("span", {
          className: ellipsisClass,
          children: children
        })]
      });
    }
    return /*#__PURE__*/_jsx("div", {
      className: theme.classes('Text', 'text', variant, className, ellipsisClass),
      "data-disabled": disabled,
      ...rest,
      children: children
    });
  }
}
export default Text;